var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',_vm._g(_vm._b({attrs:{"dense":"","outlined":"","items":_vm.items,"item-text":"displayTitle","item-value":"id"},scopedSlots:_vm._u([{key:"item",fn:function({ item }){return [_vm._v(_vm._s(item.displayTitle)),(!item.is_active)?_c('span',[_vm._v(" (inaktiv)")]):_vm._e()]}}])},'v-select',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }